<div *ngIf="visible" class="academy-data academy-data--flex">
  <div class="academy-data__icon">
    <i
      class="academy-data__cell academy-data__cell--icon fa-regular fa-triangle-exclamation"
    ></i>
  </div>
  <div class="academy-data__wrapper">
    <div class="academy-data__container" *ngFor="let warning of warnings">
      <span class="academy-data__cell academy-data__cell--title"
        >{{ warning.title | translate }}</span
      >

      <span class="academy-data__cell academy-data__cell--subtitle"
        >{{ warning.subtitle | translate}}</span
      >
      <span
        class="academy-data__cell academy-data__cell--general"
        *ngIf="warning.secondSubtitle"
        >{{ warning.secondSubtitle | translate}}</span
      >
      <span
        class="academy-data__cell academy-data__cell--general"
        *ngIf="warning.thirdSubtitle"
      >
        {{ warning.thirdSubtitle | translate}}
        <a *ngIf="warning.mailtoBecubs" href="mailto:business@becubs.com"
          >business@becubs.com</a
        >
      </span>
    </div>
  </div>
</div>
